/* =============================================================================
   FTB CART — AJAX Cart API, Quick-Add, Progress Bar, Toast
   Vanilla JS, no dependencies
   ============================================================================= */

(function () {
  'use strict';

  var CONFIRMATION_MS = 1200;

  /* ── DOM helpers ──────────────────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ── Read milestones from gift bar DOM (set by Liquid) ────────────────────── */
  function getMilestones() {
    var bar = qs('#ftb-gift-bar');
    if (!bar) return [];
    var milestones = [];
    for (var i = 1; i <= 3; i++) {
      var enabled = bar.dataset['m' + i + 'Enabled'];
      if (enabled === 'true') {
        milestones.push({
          pence: parseInt(bar.dataset['m' + i + 'Pence'], 10) || 0,
          label: bar.dataset['m' + i + 'Label'] || ''
        });
      }
    }
    return milestones;
  }

  function getMaxPence() {
    var bar = qs('#ftb-gift-bar');
    return bar ? (parseInt(bar.dataset.maxPence, 10) || 4500) : 4500;
  }

  /* ── Cart API ─────────────────────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
        return r.json();
      });
  }

  function addToCart(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: parseInt(quantity, 10) || 1,
          properties: properties || {}
        }]
      })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          throw new Error(err.description || err.message || 'Could not add item');
        });
      }
      return r.json();
    });
  }

  /* ── PDP free delivery message ───────────────────────────────────────────── */
  function updateDeliveryMessage(totalPence) {
    var el = qs('#ftb-pdp-delivery');
    if (!el) return;
    // data-static="true" means a product-specific delivery_note metafield is set — don't override
    if (el.dataset.static === 'true') return;
    var threshold = parseInt(el.dataset.threshold, 10) || 4500;
    if (totalPence >= threshold) {
      el.innerHTML = '<p class="ftb-body ftb-body--sm" style="color:var(--ftb-acid-dim);">✓ Free UK delivery unlocked</p>';
    } else {
      var gap = ((threshold - totalPence) / 100).toFixed(2);
      el.innerHTML = '<p class="ftb-body ftb-body--sm" style="color:var(--ftb-text2);">Add <strong style="color:var(--ftb-text);">£' + gap + '</strong> more for free UK delivery</p>';
    }
  }

  /* ── Update UI after any cart change ─────────────────────────────────────── */
  function onCartUpdate(cart) {
    updateCartCount(cart.item_count);
    updateGiftBar(cart.total_price);
    updateDeliveryMessage(cart.total_price);
    /* Notify all cart components (cart drawer, etc.) */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  /* ── Cart count badge ─────────────────────────────────────────────────────── */
  function updateCartCount(count) {
    qsa('.ftb-cart-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  /* ── Gift progress bar ────────────────────────────────────────────────────── */
  function updateGiftBar(totalPence) {
    var bar = qs('#ftb-gift-bar');
    if (!bar) return;

    var fill    = qs('.ftb-gift-bar__fill', bar);
    var message = qs('#ftb-gift-bar-message', bar);
    var milestones = getMilestones();
    var maxPence   = getMaxPence();

    var progress = maxPence > 0 ? Math.min((totalPence / maxPence) * 100, 100) : 0;
    if (fill) fill.style.width = progress + '%';

    // Find next unmet milestone
    var next = null;
    for (var i = 0; i < milestones.length; i++) {
      if (totalPence < milestones[i].pence) { next = milestones[i]; break; }
    }

    if (message) {
      if (next) {
        var remaining = ((next.pence - totalPence) / 100).toFixed(2);
        message.innerHTML = "You're <strong>£" + remaining + "</strong> away from " + next.label;
      } else if (milestones.length > 0) {
        message.innerHTML = '<strong>' + milestones[milestones.length - 1].label + '</strong> unlocked!';
      }
    }

    qsa('.ftb-gift-bar__milestone', bar).forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10);
      el.classList.toggle('is-reached', totalPence >= threshold);
    });
  }

  /* ── Toast ────────────────────────────────────────────────────────────────── */
  var toastTimer;
  function showToast(msg) {
    var toast = qs('#ftb-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
  }

  /* ── Quick-Add ────────────────────────────────────────────────────────────── */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;

      var variantId = btn.dataset.variantId;

      // Multi-variant: navigate to PDP
      if (btn.dataset.hasVariants === 'true') {
        window.location.href = btn.dataset.productUrl;
        return;
      }

      if (!variantId || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      btn.textContent = '…';

      addToCart(variantId, 1)
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          onCartUpdate(cart);
          btn.textContent = '✓';
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          showToast('Added to basket');
          setTimeout(function () {
            btn.textContent = '+';
            btn.classList.remove('is-added');
          }, CONFIRMATION_MS);
        })
        .catch(function (err) {
          btn.textContent = '+';
          btn.classList.remove('is-loading');
          showToast(err.message || 'Could not add item — please try again');
        });
    });
  }

  /* ── Main ATC form (PDP) ──────────────────────────────────────────────────── */
  function initAtcForm() {
    var form = qs('#ftb-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = qs('[name="id"]', form);
      var qtyInput     = qs('[name="quantity"]', form);
      if (!variantInput || !variantInput.value) return;

      var btn = qs('[type="submit"]', form);
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      addToCart(variantInput.value, qtyInput ? qtyInput.value : 1)
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          onCartUpdate(cart);
          document.dispatchEvent(new CustomEvent('cart:item-added'));
          if (btn) {
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.disabled = false; btn.textContent = 'ADD TO BASKET'; }, CONFIRMATION_MS);
          }
          showToast('Added to basket');
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.textContent = 'ADD TO BASKET'; }
          showToast(err.message || 'Could not add item — please try again');
        });
    });
  }

  /* ── Qty steppers ─────────────────────────────────────────────────────────── */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="increment"],[data-action="decrement"]');
      if (!btn) return;
      var stepper = btn.closest('.ftb-qty');
      if (!stepper) return;
      var input = stepper.querySelector('input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      input.value = btn.dataset.action === 'increment' ? val + 1 : Math.max(1, val - 1);
      var stickyInput = qs('#ftb-satc-qty');
      if (stickyInput && input.id !== 'ftb-satc-qty') stickyInput.value = input.value;
      if (input.id === 'ftb-satc-qty') {
        var mainInput = qs('#ftb-atc-form [name="quantity"]');
        if (mainInput) mainInput.value = input.value;
      }
    });
  }

  /* ── Sticky ATC ───────────────────────────────────────────────────────────── */
  function initStickyAtcButton() {
    var stickyBtn = qs('#ftb-satc-btn');
    if (!stickyBtn) return;

    /* The section inline script that normally sets data-variant-id runs before
       the sticky-bar HTML is in the DOM, so the button starts with an empty id.
       Pre-fill it here at DOMContentLoaded when all HTML is parsed. */
    if (!stickyBtn.dataset.variantId) {
      var mainInput = document.getElementById('ftb-variant-id');
      if (mainInput && mainInput.value) {
        stickyBtn.dataset.variantId = mainInput.value;
      }
    }

    stickyBtn.addEventListener('click', function () {
      /* Re-read each time — variant selector JS updates data-variant-id on change */
      var variantId = stickyBtn.dataset.variantId;
      /* Final fallback: read the default/current variant straight from the form */
      if (!variantId) {
        var fallbackInput = document.getElementById('ftb-variant-id');
        if (fallbackInput) variantId = fallbackInput.value;
      }
      var qty = qs('#ftb-satc-qty');
      if (!variantId) return;
      stickyBtn.disabled = true;
      stickyBtn.textContent = 'Adding…';
      addToCart(variantId, qty ? qty.value : 1)
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          onCartUpdate(cart);
          stickyBtn.textContent = 'Added ✓';
          setTimeout(function () { stickyBtn.disabled = false; stickyBtn.textContent = 'ADD TO BASKET'; }, CONFIRMATION_MS);
          showToast('Added to basket');
        })
        .catch(function (err) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'ADD TO BASKET';
          showToast(err.message || 'Could not add item');
        });
    });
  }

  /* ── Cart mutation interceptor ───────────────────────────────────────────── */
  /* Catches external remove/change/update calls (cart page, cart drawer, etc.)
     that don't go through our own addToCart() flow. After any such mutation
     resolves OK, we re-fetch the cart and run the full UI update. */
  function initCartChangeListener() {
    var WATCHED = ['/cart/change', '/cart/update', '/cart/clear'];
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isWatched = WATCHED.some(function (w) { return url.indexOf(w) !== -1; });
      var promise = origFetch.apply(this, arguments);
      if (isWatched) {
        promise.then(function (r) {
          if (r && r.ok) {
            // Small delay so the original handler processes the response first
            setTimeout(function () {
              fetchCart().then(onCartUpdate).catch(function () {});
            }, 50);
          }
        }).catch(function () {});
      }
      return promise;
    };
  }

  /* ── Init ─────────────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    // Sync from server-rendered values
    var init = window.FTBInit || {};
    if (typeof init.cartTotal === 'number') {
      updateGiftBar(init.cartTotal);
      updateDeliveryMessage(init.cartTotal);
    }
    if (typeof init.cartCount === 'number') updateCartCount(init.cartCount);

    initCartChangeListener();
    initQuickAdd();
    initAtcForm();
    initQtySteppers();
    initStickyAtcButton();
  });

  window.FTBCart = { addToCart: addToCart, fetchCart: fetchCart, onCartUpdate: onCartUpdate, showToast: showToast };

})();
